
import { hermioneBio, ronBio, harryBio } from './dumbledoreBios'
import { hermioneReviewerReviewHinge, ronReviewerReviewBumble, harryReviewerReviewTinder } from './dumbledoreReviewerReviews'

export const hermioneReviewerProfile = {
  _id: 'hermioneReviewerProfileId',
  userId: 'hermioneUserId',
  email: 'hermione@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-hermione-4-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...hermioneBio },
  profileReviews: [
    // { ...hermioneProfileReviewHinge }
  ],
  reviewerReviews: [
    { ...hermioneReviewerReviewHinge }
  ],
}

export const ronReviewerProfile = {
  _id: 'ronReviewerProfileId',
  userId: 'ronUserId',
  email: 'ron@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-ron-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: true,
  isHotty: false,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `Open AI gpt4o mini`,
  openAIAssistantID: `NA`,
  bio: { ...ronBio },
  profileReviews: [
    // { ...ronProfileReviewBumble }
  ],
  reviewerReviews: [
    { ...ronReviewerReviewBumble }
  ],
}

export const harryReviewerProfile = {
  _id: 'harryReviewerProfileId',
  userId: 'harryUserId',
  email: 'harry@email.com',
  profilePicture: 'https://swipelytics-bizops-images.s3.us-east-1.amazonaws.com/seed-harry-5-sq.png',
  isVisible: true,
  isCoach: false,
  isAIReviewer: false,
  isHotty: true,
  isFeatured: false,
  reviewRate: 50,
  nameOfLLM: `NA`,
  openAIAssistantID: `NA`,
  bio: { ...harryBio },
  profileReviews: [
    // { ...harryProfileReviewTinder }
  ],
  reviewerReviews: [
    { ...harryReviewerReviewTinder }
  ],
}